var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{attrs:{"src":"https://storage.googleapis.com/donorconnection-df169.appspot.com/404.png"}})}
var staticRenderFns = []

export { render, staticRenderFns }